import Figure from "../../curves/figure"
import { range } from "lodash"

const neuronUrl = index =>
  `https://storage.googleapis.com/fls/nickc/circuits/curves/group_conv/${256 +
    index}.jpg`

export default class GroupConv extends Component {
  state = { activeIndex: 0 }
  render() {
    const { images } = this.props.data
    const { activeIndex } = this.state
    const count = Math.ceil(256 / 16)
    const neuronSize = 90
    const indexes = range(count).map(i => i * 16 + activeIndex)

    const Header = ({ children }) => (
      <Surface width={320} borderBottom marginBottom={20}>
        <Text size={600} marginBottom={5}>
          {children}
        </Text>
      </Surface>
    )

    return (
      <Figure>
        <Surface
          width={1600}
          flexFlow="row"
          flexWrap="wrap"
          justifyContent="center"
          alignSelf="center"
        >
          <Surface marginX={40}>
            <Header>Rotationally Invariant Units</Header>
            <Surface flexWrap="wrap" flexFlow="row" width={400}>
              {range(16).map(index => (
                <Surface
                  onMouseEnter={() => this.setState({ activeIndex: index })}
                >
                  <img
                    width={neuronSize}
                    height={neuronSize}
                    style={{
                      border: `2px solid ${
                        activeIndex === index
                          ? `rgba(228, 118, 88, 0.9)`
                          : `rgba(0, 0, 0, 0)`
                      }`,
                      transition: "300ms ease-out all",
                      borderRadius: 5,
                    }}
                    src={neuronUrl(index)}
                  />
                </Surface>
              ))}
            </Surface>
          </Surface>

          <Surface flexFlow="row" flexWrap="wrap" width={400}>
            {indexes.map((imgIndex, index) => (
              <Surface marginY={5} marginX={5}>
                <Text size={500} marginLeft={5}>
                  {(index / 16) * 360}&#176;
                </Text>
                <img
                  width={neuronSize}
                  height={neuronSize}
                  src={neuronUrl(imgIndex)}
                  style={{ borderRadius: 5 }}
                />
              </Surface>
            ))}
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
